export default __webpack_public_path__ + "static/media/loha-fms.f690aea1.jpg";